const envs = {
  env: process.env.REACT_APP_ENV || '',
  api: process.env.REACT_APP_API || '',
  captchaKey: process.env.REACT_APP_CAPTCHA_KEY || '',
}

export default envs